import { useState, useEffect } from 'react';
import { useRegisterStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { BeforeRegisterModal } from './widgets';
import { Footer } from '@widgets/footer';
import { Button } from '@shared/widgets';
import { Input } from '@shared/widgets/inputs';
import bgImg from '@assets/images/auth/bg-01.png';
import { Controller, useForm } from 'react-hook-form';

interface IFormData {
  cardNumber: string;
  phoneCountryCode: string;
  phoneNumber: string;
}

export const RegisterPage = () => {
  const registerStore = useRegisterStore();

  const [loader, setLoader] = useState<boolean>(false);
  const [formError, setFormError] = useState('');
  const [errorValidate, setErrorValidate] = useState(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(true);

  const { navigate } = useRouteHook();

  const formControl = useForm({
    mode: 'onChange',
    defaultValues: {
      cardNumber: '',
      phoneCountryCode: '',
      phoneNumber: '',
    } as IFormData,
  });

  useEffect(() => {
    if (registerStore.registerDone !== null && registerStore.registerDone !== undefined) {
      navigate(RoutePaths.registerCode.onNavigate());
    }
  }, [registerStore.registerDone]);

  const validateField = (fieldName: string, value: string) => {
    let text = '';
    let error = false;

    switch (fieldName) {
      case 'cardNumber':
        if (value.length < 1) {
          text = 'Please enter "Card number"';
          error = true;
        }
        break;
      case 'phoneCountryCode':
        if (value.length < 1) {
          text = 'Please enter "Mobile phone code"';
          error = true;
        }
        break;
      case 'phoneNumber':
        if (value.length < 1) {
          text = 'Please enter "Mobile phone number"';
          error = true;
        }
        break;
    }

    setErrorValidate(error);
    setFormError(text);

    return !error;
  };

  const sendForm = (data: IFormData) => {
    if (
      validateField('cardNumber', data.cardNumber) &&
      validateField('phoneCountryCode', data.phoneCountryCode) &&
      validateField('phoneNumber', data.phoneNumber)
    ) {
      setLoader(true);
      registerStore.register(data);
    }
  };

  return (
    <>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className='relative z-[99] h-[702px] w-full bg-right bg-no-repeat pl-[150px] text-left max-md:h-auto max-md:!bg-none max-md:pt-0 max-md:pl-0'
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <form onSubmit={formControl.handleSubmit(sendForm)}>
            <div className='w-[590px] max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12'>
              <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>Registration</h2>
              <p className='mt-2 mb-7.5 text-lg font-light text-[#4c4c4c] before:absolute before:left-0 before:mt-[15px] before:h-[1px] before:w-[125px] before:bg-[#000] max-md:text-center max-md:text-[#4c4c4c80] max-md:before:hidden'>
                Register to the world of Insignia
              </p>
              <Controller
                name='cardNumber'
                control={formControl.control}
                rules={{
                  maxLength: 100,
                }}
                render={({ field: { value, onChange } }) => (
                  <Input
                    className='mt-2 max-md:mt-4'
                    inputClassName='w-[292px]'
                    label='Enter the Last Four Digits on your Card'
                    name='cardNumber'
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              <div className='mt-2 max-md:mt-4'>
                <label className='block font-medium text-[#000] max-md:text-[#4c4c4c80]'>Mobile Number</label>
                <div className='mt-2 flex gap-2'>
                  <Controller
                    name='phoneCountryCode'
                    control={formControl.control}
                    rules={{
                      maxLength: 100,
                    }}
                    render={({ field: { value, onChange } }) => (
                      <Input inputClassName='w-[54px] max-md:!w-[54px]' name='phoneCountryCode' value={value} onChange={onChange} />
                    )}
                  />
                  <Controller
                    name='phoneNumber'
                    control={formControl.control}
                    rules={{
                      maxLength: 100,
                    }}
                    render={({ field: { value, onChange } }) => (
                      <Input
                        className='max-md:w-full'
                        inputClassName='!w-[229px] max-md:!w-full'
                        name='phoneNumber'
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
              {errorValidate && (
                <div className='mt-4 flex'>
                  <div className='mr-1 h-[13px] w-[12px] rounded-full bg-[#d0021b] text-center text-xs font-bold text-[#ffffff]'>!</div>
                  <div className='text-xs font-bold text-[#d0021b] uppercase'>{formError}</div>
                </div>
              )}
              <div className='mt-5 flex gap-4 max-md:mt-8'>
                <Button className='w-[140px] max-md:w-full' color='outlined' onClick={() => navigate(RoutePaths.login.onNavigate())}>
                  Log In
                </Button>
                <Button className='w-[140px] !px-2 max-md:w-full' isLoading={loader} onClick={formControl.handleSubmit(sendForm)}>
                  {loader ? '' : 'Generate Code'}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
      {/* TODO: NOT WORKING BEFORE */}
      <BeforeRegisterModal isOpen={isShowModal} onClose={() => setIsShowModal(false)} />
    </>
  );
};
